/* ===========================================================================
   Kirlune — scripts propios (vanilla, sin librerías)
   Cada init comprueba que su elemento existe, así el archivo sirve en todas
   las páginas. Un único arranque idempotente.
   =========================================================================== */
(function () {
  'use strict';

  var booted = false;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.mt-faq__q');
      var a = item.querySelector('.mt-faq__a');
      if (!q || !a || q.dataset.mtBound) return;
      q.dataset.mtBound = '1';
      q.addEventListener('click', function () {
        var open = item.classList.contains('mt-open');
        // cerrar hermanos del mismo bloque (accordion)
        var group = item.parentElement;
        group.querySelectorAll('.mt-faq__item.mt-open').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('mt-open');
            var oa = other.querySelector('.mt-faq__a');
            if (oa) oa.style.maxHeight = null;
          }
        });
        if (open) { item.classList.remove('mt-open'); a.style.maxHeight = null; }
        else { item.classList.add('mt-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  function initCountUp() {
    var nums = document.querySelectorAll('.mt-count[data-target]');
    if (!nums.length || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.dataset.target; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.dataset.target) || 0;
        var suffix = el.dataset.suffix || '';
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.floor(eased * target);
          el.textContent = val.toLocaleString('en-AU') + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target.toLocaleString('en-AU') + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initProducto() {
    var pdp = document.querySelector('[data-mt-main]');
    if (!pdp) return;

    // Galería: miniaturas -> imagen principal
    var mainImg = pdp.querySelector('img');
    var thumbs = document.querySelectorAll('[data-mt-thumb]');
    thumbs.forEach(function (t) {
      if (t.dataset.mtBound) return;
      t.dataset.mtBound = '1';
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full && mainImg) mainImg.src = full;
        thumbs.forEach(function (o) { o.classList.remove('mt-active'); });
        t.classList.add('mt-active');
      });
    });

    // Variantes
    var dataEl = document.querySelector('[data-mt-variants]');
    var idInput = document.querySelector('[data-mt-variant-id]');
    var priceEl = document.querySelector('[data-mt-price]');
    var addBtn = document.querySelector('[data-mt-add]');
    var addText = document.querySelector('[data-mt-add-text]');
    var selects = document.querySelectorAll('[data-mt-option]');
    if (!dataEl || !idInput || !selects.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function money(cents) {
      return 'A$' + (cents / 100).toFixed(2);
    }

    function update() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.dataset.mtOption, 10)] = s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) {
        var html = money(match.price);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += ' <s>' + money(match.compare_at_price) + '</s>' +
                  ' <span class="mt-save">Save ' + money(match.compare_at_price - match.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn && addText) {
        if (match.available) { addBtn.disabled = false; addText.textContent = addBtn.getAttribute('data-text-add') || addText.textContent; }
        else { addBtn.disabled = true; addText.textContent = 'Sold out'; }
      }
    }
    selects.forEach(function (s) {
      if (s.dataset.mtBound) return;
      s.dataset.mtBound = '1';
      s.addEventListener('change', update);
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-mt-carousel]').forEach(function (car) {
      if (car.dataset.mtBound) return;
      car.dataset.mtBound = '1';
      var track = car.querySelector('[data-mt-track]');
      var prev = car.querySelector('[data-mt-prev]');
      var next = car.querySelector('[data-mt-next]');
      var nav = car.querySelector('[data-mt-nav]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.mt-carousel__slide');
        if (!slide) return track.clientWidth * 0.8;
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '24', 10) || 24;
        return slide.getBoundingClientRect().width + gap;
      }
      function refresh() {
        var scrollable = track.scrollWidth > track.clientWidth + 4;
        if (nav) nav.hidden = !scrollable;
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(refresh); }, { passive: true });
      window.addEventListener('resize', function () { window.requestAnimationFrame(refresh); }, { passive: true });
      refresh();
    });
  }

  function initBeforeAfter() {
    document.querySelectorAll('[data-mt-ba]').forEach(function (ba) {
      if (ba.dataset.mtBound) return;
      ba.dataset.mtBound = '1';
      var wrap = ba.querySelector('.mt-ba__before-wrap');
      var handle = ba.querySelector('.mt-ba__handle');
      if (!wrap || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var rect = ba.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        wrap.style.width = pct + '%';
        handle.style.left = pct + '%';
      }
      function down(e) { dragging = true; setPos((e.touches ? e.touches[0].clientX : e.clientX)); e.preventDefault(); }
      function move(e) { if (!dragging) return; setPos((e.touches ? e.touches[0].clientX : e.clientX)); }
      function up() { dragging = false; }
      handle.addEventListener('mousedown', down);
      ba.addEventListener('mousedown', down);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      handle.addEventListener('touchstart', down, { passive: false });
      ba.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('touchend', up);
    });
  }

  function updateSectionFromResponse(res, sectionId, selector) {
    var html = res.sections && res.sections[sectionId];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function handleShipToggle(toggle) {
    var vid = toggle.getAttribute('data-variant-id');
    if (!vid) return;
    toggle.disabled = true;
    var wantOn = toggle.checked;
    var url = wantOn ? '/cart/add.js' : '/cart/change.js';
    var body = wantOn
      ? { id: vid, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }
      : { id: vid, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        updateSectionFromResponse(res, 'cart-drawer', '#CartDrawer');
        updateSectionFromResponse(res, 'cart-icon-bubble', '#cart-icon-bubble');
      })
      .catch(function () { toggle.checked = !wantOn; toggle.disabled = false; });
  }

  function initCartInsurance() {
    if (document.documentElement.dataset.mtShipBound) return;
    document.documentElement.dataset.mtShipBound = '1';
    document.addEventListener('change', function (e) {
      var toggle = e.target.closest ? e.target.closest('[data-mt-ship-toggle]') : null;
      if (toggle) handleShipToggle(toggle);
    });
  }

  function initSizeGuide() {
    if (document.documentElement.dataset.mtSgBound) return;
    document.documentElement.dataset.mtSgBound = '1';
    function closeAll() {
      var m = document.querySelector('[data-mt-sizeguide]');
      if (m) { m.hidden = true; document.body.style.overflow = ''; }
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-mt-sizeguide-open]')) {
        var m = document.querySelector('[data-mt-sizeguide]');
        if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
      } else if (e.target.closest && e.target.closest('[data-mt-sizeguide-close]')) {
        closeAll();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  function initStickyBar() {
    var bar = document.querySelector('.mt-stickybar');
    if (!bar || bar.dataset.mtBound) return;
    bar.dataset.mtBound = '1';
    var main = document.getElementById('MainContent') || document.body;
    function sync() {
      main.style.paddingTop = bar.getBoundingClientRect().height + 'px';
    }
    sync();
    window.addEventListener('resize', sync);
  }

  function initBundle() {
    var bundle = document.querySelector('[data-mt-bundle]');
    if (!bundle || bundle.dataset.mtBound) return;
    bundle.dataset.mtBound = '1';

    var radios = bundle.querySelectorAll('input[name="mt-bundle-choice"]');
    var idInput = document.querySelector('[data-mt-variant-id]');
    var priceEl = document.querySelector('[data-mt-price]');
    var variantsEl = document.querySelector('[data-mt-variants]');
    var variants = [];
    if (variantsEl) { try { variants = JSON.parse(variantsEl.textContent); } catch (e) {} }

    function money(cents) { return 'A$' + (cents / 100).toFixed(2); }

    function apply(radio) {
      var vid = radio.value;
      if (idInput) idInput.value = vid;
      if (priceEl) {
        var priceCents = radio.dataset.priceCents;
        var compareCents = radio.dataset.compareCents;
        var html;
        if (priceCents !== undefined) {
          var p = parseInt(priceCents, 10);
          var c = parseInt(compareCents, 10);
          html = money(p);
          if (compareCents && c > p) {
            html += ' <s>' + money(c) + '</s> <span class="mt-save">Save ' + money(c - p) + '</span>';
          }
        } else {
          var match = variants.find(function (v) { return String(v.id) === String(vid); });
          if (match) {
            html = money(match.price);
            if (match.compare_at_price && match.compare_at_price > match.price) {
              html += ' <s>' + money(match.compare_at_price) + '</s> <span class="mt-save">Save ' + money(match.compare_at_price - match.price) + '</span>';
            }
          }
        }
        if (html) priceEl.innerHTML = html;
      }
      radios.forEach(function (r) {
        var opt = r.closest('.mt-bundle__opt');
        if (opt) opt.classList.toggle('mt-bundle__opt--active', r === radio);
      });
      document.querySelectorAll('[data-mt-bundle-sizes]').forEach(function (box) {
        var isHidden = box.getAttribute('data-for') !== vid;
        box.hidden = isHidden;
        box.querySelectorAll('select').forEach(function (sel) { sel.disabled = isHidden; });
      });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { apply(r); });
    });
    var checked = bundle.querySelector('input[name="mt-bundle-choice"]:checked');
    if (checked) apply(checked);
  }

  function initPairsWell() {
    if (document.documentElement.dataset.mtPairsBound) return;
    document.documentElement.dataset.mtPairsBound = '1';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mt-pairs-add]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';

      var cartDrawer = document.querySelector('cart-drawer');
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cartDrawer && cartDrawer.getSectionsToRender) {
        formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || 'Cart error');
          if (cartDrawer && cartDrawer.renderContents) {
            // Dawn marca el cajón como "vacío"; hay que quitarlo o no se ve el
            // artículo recién añadido (mismo paso que hace product-form.js).
            cartDrawer.classList.remove('is-empty');
            var drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');
            cartDrawer.renderContents(data);
            cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          console.error(err);
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = originalText; }, 1500);
        })
        .finally(function () {
          btn.disabled = false;
          if (btn.textContent === '…') btn.textContent = originalText;
        });
    });
  }

  function bootOnce() {
    if (booted) { initReveals(); initFaq(); initProducto(); initCarousels(); initBeforeAfter(); initBundle(); initPairsWell(); return; }
    booted = true;
    initReveals();
    initFaq();
    initCountUp();
    initProducto();
    initCarousels();
    initBeforeAfter();
    initCartInsurance();
    initSizeGuide();
    initBundle();
    initStickyBar();
    initPairsWell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOnce);
  } else {
    bootOnce();
  }
  window.addEventListener('load', bootOnce);
  document.addEventListener('shopify:section:load', bootOnce);
})();
